import { getColumnNameFromGeoColumn, getSpatialIndexFromGeoColumn } from 'features/builder/state/builderSliceUtils'
import { formatPGRSSource } from '../../utils'

export const generateCreateTableFromQuery = ({ output, query, geoColumn }) => {
  const formattedOutput = formatPGRSSource(output)
  const geoColumnName = getColumnNameFromGeoColumn(geoColumn)
  const spatialIndex = getSpatialIndexFromGeoColumn(geoColumn)
  const result = `CREATE TABLE ${formattedOutput} AS (
    ${query}
  );`

  if (spatialIndex) {
    return `
      ${result}
      ALTER TABLE ${formattedOutput} ALTER SORTKEY (${geoColumnName});
    `
  }
  return result
}
